/**
 * Bar chart used for both `monthly_liters` and `monthly_spending` — ports
 * `renderMonthlyBar()` from the legacy `static/analysis.js`. Caller picks
 * the color and label so a single component covers both metrics.
 */

import { Bar } from "react-chartjs-2";

import { ensureChartDefaults } from "./chartDefaults";
import { usePalette } from "./usePalette";
import type { MonthlyPoint } from "../../../api/types";

export interface MonthlyBarChartProps {
  points: MonthlyPoint[];
  label: string;
  color: string;
  unit: string;
}

export default function MonthlyBarChart({
  points,
  label,
  color,
  unit,
}: MonthlyBarChartProps) {
  const palette = usePalette();
  ensureChartDefaults(palette);

  const data = {
    labels: points.map((p) => p.month),
    datasets: [
      {
        label,
        data: points.map((p) => p.value),
        backgroundColor: color,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          callback: (value: string | number) =>
            `${(Number(value) || 0).toFixed(0)} ${unit}`,
        },
      },
    },
    plugins: { legend: { display: false } },
  } as const;

  return <Bar data={data} options={options} />;
}
